import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { getModule as getStoreModule } from 'vuex-module-decorators';
import GlobalsStoreModule from '@app/store/modules/GlobalsStoreModule';
import PresentationStoreModule from '../store/modules/PresentationStoreModule';
import IGlobalAppSettings from '../types/base/IGlobalAppSettings';
import AppModule from '../types/base/AppModule';
import AppStoreModule from '../store/modules/AppStoreModule';

// we need the store outside the class scope as it is accessed in prop default functions before Vue instances exist
const appStore: AppStoreModule = getStoreModule(AppStoreModule);
const globalsStore: GlobalsStoreModule = getStoreModule(GlobalsStoreModule);
const presentationStore: PresentationStoreModule = getStoreModule(PresentationStoreModule);
let uid = 0;

export default class GlobalsMixin extends Vue {
	public props: Record<string, any> = {
		global: {
			type: Object,
			default(): IGlobalAppSettings {
				let global: IGlobalAppSettings = {
					locale: process.env.PRESENTATION_DEFAULT_LOCALE || '',
					staticUI: false,
					activeAppModule: AppModule.Unknown
				};

				if (this && this.$parent && this.$parent.global) global = { ...global, ...this.$parent.global };

				if (appStore && appStore.localeCode) global = { ...global, locale: appStore.localeCode };

				if (appStore && appStore.activeAppModule) global = { ...global, activeAppModule: appStore.activeAppModule };

				global = { ...global, staticUI: !!presentationStore.settingsWithOverrides.staticUI };

				return global;
			}
		},
		i18n: {
			type: Object,
			default(): Record<string, any> {
				let i18n: Record<string, any>;

				// Make sure to always re-use existing objects otherwise the Vue reactivity will be lost
				if (this && this.$parent && this.$parent.i18n) {
					i18n = this.$parent.i18n;
				} else {
					i18n = {};
				}

				if (globalsStore && globalsStore.i18n && Object.keys(globalsStore.i18n).length) {
					Object.assign(i18n, globalsStore.i18n);
				}

				return i18n;
			}
		},
		uid: {
			type: String,
			default(): string {
				return this && this.id ? this.id : (++uid).toString();
			}
		}
	};

	@Prop(Object)
	public readonly i18n!: Record<string, string>;

	@Prop(Object)
	public readonly global?: Record<string, string>;

	@Prop(String)
	public readonly uid?: string;

	public componentId?: string;

	public beforeCreate(): void {
		if (!this.$vnode) {
			return;
		}

		if (!this.$vnode.data) {
			this.$vnode.data = {};
		}

		if (!this.$vnode.data.attrs) {
			this.$vnode.data.attrs = {};
		}

		if (!this.$vnode.data.attrs.id && this.$options.propsData && (this.$options.propsData as any).id) {
			this.$vnode.data.attrs.id = (this.$options.propsData as any).id;
		}

		const { componentId } = this.$options as any;

		if (componentId) {
			this.$vnode.data.attrs['data-component-id'] = componentId;
		}
	}
}
